/* « Recommencer ma commande » après un paiement annulé (Jen, 01.11.2026) : le panier, gardé
   sur CE navigateur juste avant de partir vers la page de paiement, revient tout rempli.
   Rien ne part ailleurs ; effacé une fois payé, et oublié après 24 heures. */
const CLE = "billets_reprise";
const DUREE = 24 * 60 * 60 * 1000;

export const garderPanier = (contenu) => {
  try { localStorage.setItem(CLE, JSON.stringify({ ...contenu, le: Date.now() })); } catch { /* navigation privée */ }
};

export const lirePanier = () => {
  try {
    const s = JSON.parse(localStorage.getItem(CLE) || "null");
    return s && Date.now() - (s.le || 0) < DUREE ? s : null;
  } catch { return null; }
};

export const oublierPanier = () => {
  try { localStorage.removeItem(CLE); } catch { /* navigation privée */ }
};
